import React from "react";
import { API } from "../../constants";
import useAuthStore from "../../hooks/useAuthStore";

export default function AuthInitializer({ children }) {
  const { setUser, clearUser, setLoading } = useAuthStore();

  React.useEffect(() => {
    const checkSession = async () => {
      try {
        const res = await fetch(API.CUSTOMER_PROFILE, {
          method: "GET",
          credentials: "include",
        });

        const data = await res.json();

        if (res.ok && data.status === true) {
          setUser(data.data);
        } else {
          clearUser();
        }
      } catch (error) {
        clearUser();
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  return children;
}